import { Role } from 'domain/shared/core/constants';
import { ButtonWithConfirmation } from 'framework/ui/ui-builder';
import { UPDATE_EMPLOYEE_COMPANY_ROLES, useCompanyRolesService } from '../../shared/companyRolesService';
import { useShowContext } from 'framework/show';
import { useListContext } from 'framework/list';
import RemoveIcon from '@mui/icons-material/RemoveOutlined';
import IconButton from '@mui/material/IconButton';

const RemoveEmployeeCompanyRoleButton = (props: any) => {
  const { removeRoleFromEmployee } = useCompanyRolesService();
  const { data: rowData } = useShowContext();
  const { setData } = useListContext();

  const role: Role = rowData.getData().name;

  const deleteFromListByName = () =>
    setData &&
    setData((prevData: { items: { name: string }[] }) => {
      const items = prevData.items.filter(item => item.name !== role);

      return {
        ...prevData,
        items,
        totalElements: items.length,
      };
    });

  return (
    <>
      <ButtonWithConfirmation
        permissionToCheck={UPDATE_EMPLOYEE_COMPANY_ROLES}
        modalConfirmButtonText="Delete"
        buttonTag={IconButton}
        variant="outlined"
        sx={{
          p: 0,
          minWidth: 'auto',
          width: 'auto !important',
        }}
        submitMethod={async () => removeRoleFromEmployee(role)}
        displayMessage={`Do you really want to remove ${role} role from the worker?`}
        afterSubmit={{
          successMessage: 'The company role has been successfully removed.',
          errorMessage: "Can't remove company role.",
          execute: deleteFromListByName,
        }}
      >
        <RemoveIcon fontSize="small" />
      </ButtonWithConfirmation>
    </>
  );
};

export default RemoveEmployeeCompanyRoleButton;
